<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'CommentDisputeHistoryActionBtn',
  mixins: [baseMixin],
  props: {
    selected: {
      type: Boolean,
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <v-btn
    outlined
    color="primary"
    :style="{ background: isDarkMode ? '' : 'white' }"
    class="px-8"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
  >
    <v-icon v-if="selected" left>mdi-check</v-icon> {{ text }}
  </v-btn>
</template>
